document.addEventListener("turbo:load", () => {
  const chartEl = document.querySelector("#revenue-chart");
  if (chartEl && window.ApexCharts) {
    // Fetch sales data from Rails controller
    fetch("/dashboard/sales_data")
      .then(response => response.json())
      .then(data => {
        const categories = data.map(item => item.date);
        const seriesData = data.map(item => item.total);

        const options = {
          series: [
            { name: "Sales", data: seriesData }
          ],
          chart: { height: 300, type: "area", toolbar: { show: false } },
          legend: { show: false },
          colors: ["#0d6efd"],
          dataLabels: { enabled: false },
          stroke: { curve: "smooth" },
          xaxis: {
            type: "datetime",
            categories: categories
          },
          tooltip: { x: { format: "dd MMM yyyy" } },
        };

        new ApexCharts(chartEl, options).render();
      })
      .catch(error => console.error("Error loading sales data:", error));
  }
});
